import { createAsyncThunk } from '@reduxjs/toolkit';

import API from '../../API/Main/API';
import {
	AiCheckSoapNoteCoverageRequest,
	AiCheckSoapNoteCoverageResponse,
	AiParseSoapNoteRequest,
	AiParseSoapNoteResponse,
} from '../../API/ClientAPIHelpers/ai';

export const parseSoapNoteWithAi = createAsyncThunk(
	'soapNote/ai/parse',
	async (data: AiParseSoapNoteRequest, thunkAPI) => {
		const response = await API.ClientAPI.Ai.parseSoapNote(data);

		if (response.error) {
			return thunkAPI.rejectWithValue(response.error);
		}

		return response as AiParseSoapNoteResponse;
	},
);

export const checkSoapNoteCoverage = createAsyncThunk(
	'soapNote/ai/checkCoverage',
	async (data: AiCheckSoapNoteCoverageRequest, thunkAPI) => {
		const response = await API.ClientAPI.Ai.checkSoapNoteCoverage(data);

		if (response.error) {
			return thunkAPI.rejectWithValue(response.error);
		}

		return response as AiCheckSoapNoteCoverageResponse;
	},
);
